// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__wQ6St","consentsList":"PatientConsents_consentsList__2a0Te","consentsListEmpty":"PatientConsents_consentsListEmpty__2nGad"};